<template>
  <div id="step8">
    <div class="flex align-center container">
      <div class="row flex align-center">
        <left-content :step="step" />
        <right-content/>
      </div>
    </div>
  </div>
</template>

<script>
import LeftContent from "@/modules/moduleA/components/contents/LeftContent";
import RightContent from "@/modules/moduleA/components/contents/RightContent";
export default {
  name: "Step8",
  components: {RightContent, LeftContent},
  data(){
    return {
      step:{
        title:"step.8",
        context:"内石をお留めしますか",
        btnText:"選択",
      }
    }
  }
}
</script>
